const idPrefix = 'TwilioMessage';

const generateMessageId = (index: number) => `${idPrefix}-${index}`;

export default generateMessageId;
